import { React, PT, WithData, withRouter, fetchApi } from '@gasbuddy/react';
import moment from 'moment';
import { Dimmer, Loader, Table, Segment, Input, Button, Icon } from 'semantic-ui-react';
import { Auth, Nav } from '../../components';
import { Role } from '../../roles';
import EditCategoryModal from './EditCategoryModal';

class BaseCategories extends React.Component {
  state = {
    column: 'merchant_name',
    direction: 'ascending',
  }

  handleSort = clickedColumn => () => {
    const { column, direction } = this.state;

    if (column !== clickedColumn) {
      this.setState({
        column: clickedColumn,
        direction: 'ascending',
      });
    } else {
      this.setState({
        direction: direction === 'ascending' ? 'descending' : 'ascending',
      });
    }
  }

  onSelected = (category) => {
    this.setState({ category });
  }

  onDismiss = () => {
    this.setState({ category: null });
  }

  publish = () => {
    this.setState({ reloading: true }, async () => {
      await fetchApi({
        url: '/loyalty/categories/reload',
        body: {},
      });
      this.setState({ reloading: false });
    });
  }

  render() {
    const { column, direction, search, category } = this.state;
    const { data, loading } = this.props;
    const { pending, reloading } = this.state;

    const dir = direction === 'ascending' ? 1 : -1;
    const categories = data ? (data.categories || [])
      .filter((entry) => {
        if (!search) {
          return true;
        }
        if (search.length < 4) {
          return entry.source_category?.toLowerCase().startsWith(search.toLowerCase())
            || entry.internal_name?.toLowerCase().startsWith(search.toLowerCase())
            || entry.display_name?.toLowerCase().startsWith(search.toLowerCase());
        }
        return entry.source_category?.toLowerCase().includes(search.toLowerCase())
          || entry.internal_name?.toLowerCase().includes(search.toLowerCase())
          || entry.display_name?.toLowerCase().includes(search.toLowerCase());
      })
      .sort((a, b) => {
        switch (column) {
          case 'id':
            return (a.display_category_id - b.display_category_id) * dir;
          case 'rate':
            return ((a.extra_data?.rate_fixed || a.extra_data?.rate_percent || -1) - (b.extra_data?.rate_fixed || b.extra_data?.rate_percent || -1)) * dir;
          case 'sort':
            return ((a.extra_data?.sort || Number.MAX_SAFE_INTEGER) - (b.extra_data?.sort || Number.MAX_SAFE_INTEGER)) * dir;
          case 'internal_name':
            return (a.internal_name.localeCompare(b.internal_name)) * dir;
          case 'display_name':
            return (a.display_name.localeCompare(b.display_name)) * dir;
          case 'source_category':
            return (a.source_category.localeCompare(b.source_category)) * dir;
          case 'created_at':
            return (moment(a.created_at).valueOf() - moment(b.created_at).valueOf()) * dir;
          default:
            return 0;
        }
      }) : [];

    return (
      <Auth forRoles={[Role.Superuser, Role.GasBackCampaigns]}>
        <Nav>
          <div>
            {category && <EditCategoryModal category={category} onDismiss={this.onDismiss} />}
            <h1>Category Mappings</h1>
            <Dimmer.Dimmable as={Segment} dimmed={loading || pending}>
              <Dimmer active={loading || pending}>
                <Loader />
              </Dimmer>
              <Table sortable striped selectable>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell colSpan="7">
                      <Input icon="search" placeholder="Search..." onChange={(e, { value }) => this.setState({ search: value })} />
                    </Table.HeaderCell>
                    <Table.HeaderCell colSpan="2">
                      <Button loading={reloading} onClick={this.publish}>Publish Changes</Button>
                    </Table.HeaderCell>
                  </Table.Row>
                  <Table.Row>
                    <Table.HeaderCell sorted={column === 'id' && direction} width={1} onClick={this.handleSort('id')}>Id</Table.HeaderCell>
                    <Table.HeaderCell textAlign="center" sorted={column === 'created_at' && direction} onClick={this.handleSort('created_at')}>Created</Table.HeaderCell>
                    <Table.HeaderCell sorted={column === 'internal_name' && direction} onClick={this.handleSort('internal_name')}>Merchant</Table.HeaderCell>
                    <Table.HeaderCell sorted={column === 'source_category' && direction} onClick={this.handleSort('source_category')}>Raw Category</Table.HeaderCell>
                    <Table.HeaderCell>Summary</Table.HeaderCell>
                    <Table.HeaderCell>Detail</Table.HeaderCell>
                    <Table.HeaderCell sorted={column === 'sort' && direction} onClick={this.handleSort('sort')}>Sort</Table.HeaderCell>
                    <Table.HeaderCell sorted={column === 'rate' && direction} onClick={this.handleSort('rate')}>Observed Rate</Table.HeaderCell>
                    <Table.HeaderCell width={1}>Hidden</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {categories.map(d => (
                    <Table.Row
                      key={d.display_category_id}
                      onClick={() => this.onSelected(d)}
                    >
                      <Table.Cell>{d.display_category_id}</Table.Cell>
                      <Table.Cell textAlign="center">{moment(d.created_at).format('MM/DD/YYYY HH:MM:ss')}</Table.Cell>
                      <Table.Cell>{d.internal_name}</Table.Cell>
                      <Table.Cell>{d.source_category}</Table.Cell>
                      <Table.Cell>{d.summary}</Table.Cell>
                      <Table.Cell>{d.detail}</Table.Cell>
                      <Table.Cell>{d.extra_data?.sort || '-'}</Table.Cell>
                      <Table.Cell textAlign="center">
                        {`${d.extra_data?.rate_fixed ? '$' : ''}${d.extra_data?.rate_percent || d.extra_data?.rate_fixed || '-'}${d.extra_data?.rate_percent ? '%' : ''}`}
                      </Table.Cell>
                      <Table.Cell textAlign="center">
                        {d.extra_data?.hide && <Icon name="checkmark" />}
                      </Table.Cell>
                    </Table.Row>
                  ))}
                </Table.Body>
              </Table>
            </Dimmer.Dimmable>
          </div>
        </Nav>
      </Auth>
    );
  }
}

BaseCategories.propTypes = {
  data: PT.shape({
    campaigns: PT.arrayOf(PT.shape({
      name: PT.string,
    })),
  }),
  loading: PT.bool,
};

BaseCategories.defaultProps = { loading: false, data: null };

export default withRouter(() => (
  <WithData url="/loyalty/categories">
    <BaseCategories />
  </WithData>
));
